// Utils and Service
import { getErrorMessage, isCanceledError } from '../utils/helpers'

import axios from './instance'

/**
 * Gets the list of Dealers.
 * @param {string} url
 * @param {func} setLoading
 * @param {func} setError
 * @param {AbortSignal} signal - cancels the request when a newer one supersedes it
 * @returns `data` results
 */
export const getDealers = async (
  url,
  setLoading = () => {},
  setError = () => {},
  signal = undefined,
) => {
  setLoading(true)

  try {
    const data = await axios.get(url, { signal })

    setLoading(false)
    return data
  } catch (err) {
    // Superseded by a newer request; leave loading state for the in-flight one.
    if (isCanceledError(err)) return null

    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Gets the KPIs using the specified `url`.
 * @param {string} url
 * @param {func} setLoading
 * @param {func} setError
 * @param {AbortSignal} signal - cancels the request when a newer one supersedes it
 * @returns `data` results
 */
export const getDealerKpis = async (
  url,
  setLoading = () => {},
  setError = () => {},
  signal = undefined,
) => {
  setLoading(true)

  try {
    const data = await axios.get(url, { signal })

    setLoading(false)
    return data
  } catch (err) {
    // Superseded by a newer request; leave loading state for the in-flight one.
    if (isCanceledError(err)) return null

    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Gets the list of filter options using the specified `url`.
 * @param {string} url
 * @param {func} setLoading
 * @param {func} setError
 * @param {AbortSignal} signal - cancels the request when a newer one supersedes it
 * @returns `data` results
 */
export const getFilterListOptions = async (
  url,
  setLoading = () => {},
  setError = () => {},
  signal = undefined,
) => {
  setLoading(true)

  try {
    const data = await axios.get(url, { signal })

    setLoading(false)
    return data
  } catch (err) {
    // Superseded by a newer request; leave loading state for the in-flight one.
    if (isCanceledError(err)) return null

    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/**
 * Gets the list of dealer groups
 * @param {string} filters
 * @param {func} setError
 * @param {func} setLoading
 * @returns `data` results
 */
export const getDealerGroups = async (filters, setLoading = () => {}, setError = () => {}) => {
  setLoading(true)

  try {
    const data = await axios.get(`/dealers/dealer-groups/${filters}`)

    setLoading(false)
    return data
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

// ------------------------------------ Exports ------------------------------------

/*
 * Creates a dealers export with the specified `url`.
 * @param {string} url
 * @param {func} setError
 * @param {func} setLoading
 */
export const createDealerExport = async (url, setError = () => {}, setLoading = () => {}) => {
  setLoading(true)

  try {
    const response = await axios.post(url)

    setLoading(false)
    return response
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}

/*
 * Gets the dealers export with the specified `exportId`.
 * @param {string} exportId
 * @param {func} setError
 * @param {func} setLoading
 */
export const getDealerExport = async (exportId, setError = () => {}, setLoading = () => {}) => {
  setLoading(true)

  try {
    const response = await axios.get(`/dealer-exports/${exportId}`)

    setLoading(false)
    return response
  } catch (err) {
    setError(getErrorMessage(err))
    setLoading(false)
    return null
  }
}
